/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './common';
import '../common/currency';
import '../merchant/api';
import '../common/location';
import '../connect/v2/catalog/resources/datatypes';
import '../connect/v2/catalog/resources/enums';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "inventory": {
        "nested": {
          "v3": {
            "nested": {
              "ProductType": {
                "values": {
                  "DO_NOT_USE_PRODUCT_TYPE": 0,
                  "ITEM": 1,
                  "ITEM_VARIATION": 2,
                  "ITEM_MODIFIER_OPTION": 3
                }
              },
              "TrackingState": {
                "values": {
                  "DO_NOT_USE_TRACKING_STATE": 0,
                  "NOT_TRACKED": 1,
                  "TRACKED": 2,
                  "LOCKED": 3,
                  "DELETED": 4,
                  "UNRECOGNIZED": 5
                }
              },
              "AccountingMethod": {
                "values": {
                  "DO_NOT_USE_ACCOUNTING_METHOD": 0,
                  "FIFO": 1,
                  "LIFO": 2,
                  "AVERAGE": 3
                }
              },
              "InventoryObjectType": {
                "values": {
                  "DO_NOT_USE_OBJECT_TYPE": 0,
                  "CURRENT_COUNT": 1,
                  "ADJUSTMENT": 3,
                  "STOCK_COUNT": 4,
                  "PRODUCT_STATE": 5,
                  "CURRENT_PRODUCT_STATE": 6,
                  "PRODUCT_CONFIGURATION": 7
                }
              },
              "State": {
                "fields": {
                  "sqState": {
                    "type": ".squareup.inventory.v3.State.SqState",
                    "id": 1,
                    "rule": "optional"
                  },
                  "customState": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "SqState": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CUSTOM": 1,
                      "IN_STOCK": 2,
                      "SOLD": 3,
                      "RETURNED_BY_CUSTOMER": 4,
                      "RESERVED_FOR_SALE": 5,
                      "SOLD_ONLINE": 6,
                      "ORDERED_FROM_SUPPLIER": 7,
                      "RECEIVED_FROM_SUPPLIER": 8,
                      "IN_TRANSIT_TO": 9,
                      "NONE": 10,
                      "WASTE": 11,
                      "UNACCOUNTED": 12,
                      "UNLINKED_RETURN": 13,
                      "COMPOSED": 14,
                      "DECOMPOSED": 15,
                      "IN_TRANSIT": 16,
                      "UNTRACKED": 17
                    }
                  }
                }
              },
              "Quantity": {
                "fields": {
                  "count": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fractionalCount": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isEstimated": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ProductIdentifier": {
                "fields": {
                  "merchantCatalogToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "legacyCogsIdIdentifier": {
                    "type": ".squareup.inventory.v3.LegacyCogsIdentifier",
                    "id": 2,
                    "rule": "optional"
                  },
                  "readOnlyProductType": {
                    "type": ".squareup.inventory.v3.ProductType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "catalogVersion": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "LegacyCogsIdentifier": {
                "fields": {
                  "legacyCogsId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Count": {
                "fields": {
                  "productIdentifier": {
                    "type": ".squareup.inventory.v3.ProductIdentifier",
                    "id": 1,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.inventory.v3.State",
                    "id": 2,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": ".squareup.inventory.v3.Quantity",
                    "id": 3,
                    "rule": "optional"
                  },
                  "quantityDecimal": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "countedAt": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "countedBy": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "inventoryType": {
                    "type": ".squareup.inventory.inventory_common.InventoryType",
                    "id": 10,
                    "rule": "optional"
                  },
                  "referenceId": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "forced": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional"
                  },
                  "csvImportId": {
                    "type": "string",
                    "id": 8
                  },
                  "connectOauthClientId": {
                    "type": "string",
                    "id": 9
                  },
                  "countingSessionId": {
                    "type": "string",
                    "id": 14
                  }
                },
                "nested": {
                  "associated_event": {
                    "oneof": ["csvImportId", "connectOauthClientId", "countingSessionId"]
                  }
                }
              },
              "Adjustment": {
                "fields": {
                  "productIdentifier": {
                    "type": ".squareup.inventory.v3.ProductIdentifier",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fromState": {
                    "type": ".squareup.inventory.v3.State",
                    "id": 2,
                    "rule": "optional"
                  },
                  "toState": {
                    "type": ".squareup.inventory.v3.State",
                    "id": 3,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": ".squareup.inventory.v3.Quantity",
                    "id": 4,
                    "rule": "optional"
                  },
                  "quantityDecimal": {
                    "type": "string",
                    "id": 30,
                    "rule": "optional"
                  },
                  "occurredAt": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "forced": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "cost": {
                    "type": ".squareup.common.Money",
                    "id": 14,
                    "rule": "optional"
                  },
                  "totalSalesPrice": {
                    "type": ".squareup.common.Money",
                    "id": 16,
                    "rule": "optional"
                  },
                  "adjustedBy": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "inventoryType": {
                    "type": ".squareup.inventory.inventory_common.InventoryType",
                    "id": 18,
                    "rule": "optional"
                  },
                  "totalCost": {
                    "type": ".squareup.common.Money",
                    "id": 22,
                    "rule": "optional"
                  },
                  "referenceId": {
                    "type": "string",
                    "id": 23,
                    "rule": "optional"
                  },
                  "readOnlyUnitCost": {
                    "type": ".squareup.common.Money",
                    "id": 24,
                    "rule": "optional"
                  },
                  "readOnlyInferred": {
                    "type": "bool",
                    "id": 25,
                    "rule": "optional"
                  },
                  "vendorToken": {
                    "type": "string",
                    "id": 31,
                    "rule": "optional"
                  },
                  "adjustmentGroup": {
                    "type": ".squareup.inventory.v3.AdjustmentGroup",
                    "id": 32,
                    "rule": "optional"
                  },
                  "taxTotalCost": {
                    "type": ".squareup.common.Money",
                    "id": 35,
                    "rule": "optional"
                  },
                  "feeTotalCost": {
                    "type": ".squareup.common.Money",
                    "id": 36,
                    "rule": "optional"
                  },
                  "inferredFromStockCountToken": {
                    "type": "string",
                    "id": 37,
                    "rule": "optional"
                  },
                  "purchaseOrderToken": {
                    "type": "string",
                    "id": 9
                  },
                  "salesOrderId": {
                    "type": "string",
                    "id": 10
                  },
                  "legacyBulkImportId": {
                    "type": "string",
                    "id": 12
                  },
                  "connectOauthClientId": {
                    "type": "string",
                    "id": 15
                  },
                  "waiterFeedToken": {
                    "type": "string",
                    "id": 21
                  },
                  "billToken": {
                    "type": "string",
                    "id": 27
                  },
                  "linkedReturnBillToken": {
                    "type": "string",
                    "id": 28
                  },
                  "bulkAdjustToken": {
                    "type": "string",
                    "id": 29
                  },
                  "transferOrderToken": {
                    "type": "string",
                    "id": 33
                  },
                  "commitmentToken": {
                    "type": "string",
                    "id": 34
                  }
                },
                "nested": {
                  "associated_event": {
                    "oneof": ["purchaseOrderToken", "salesOrderId", "legacyBulkImportId", "connectOauthClientId", "waiterFeedToken", "billToken", "linkedReturnBillToken", "bulkAdjustToken", "transferOrderToken", "commitmentToken"]
                  }
                }
              },
              "AdjustmentGroup": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "rootAdjustmentToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fromState": {
                    "type": ".squareup.inventory.v3.State",
                    "id": 3,
                    "rule": "optional"
                  },
                  "toState": {
                    "type": ".squareup.inventory.v3.State",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "CostLot": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "accountingMethod": {
                    "type": ".squareup.inventory.v3.AccountingMethod",
                    "id": 2,
                    "rule": "optional"
                  },
                  "productIdentifier": {
                    "type": ".squareup.inventory.v3.ProductIdentifier",
                    "id": 3,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.inventory.v3.State",
                    "id": 4,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": ".squareup.inventory.v3.Quantity",
                    "id": 5,
                    "rule": "optional"
                  },
                  "cost": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "parentLotToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "proximateAdjustment": {
                    "type": ".squareup.inventory.v3.Adjustment",
                    "id": 8,
                    "rule": "optional"
                  },
                  "originalAdjustment": {
                    "type": ".squareup.inventory.v3.Adjustment",
                    "id": 9,
                    "rule": "optional"
                  },
                  "consumedByAdjustment": {
                    "type": ".squareup.inventory.v3.Adjustment",
                    "id": 10,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "consumedAt": {
                    "type": "int64",
                    "id": 13,
                    "rule": "optional"
                  },
                  "vendorToken": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "isUnaccounted": {
                    "type": "bool",
                    "id": 15,
                    "rule": "optional"
                  }
                }
              },
              "PurchaseOrderState": {
                "values": {
                  "PO_DO_NOT_USE": 0,
                  "PO_DRAFT": 1,
                  "PO_PENDING": 2,
                  "PO_RECEIVING": 3,
                  "PO_RECEIVED": 4,
                  "PO_CANCELED": 5,
                  "PO_AUTO": 6
                }
              },
              "PurchaseOrderLineState": {
                "values": {
                  "PO_LINE_DO_NOT_USE": 0,
                  "PO_LINE_OPEN": 1,
                  "PO_LINE_RECEIVED": 2,
                  "PO_LINE_DAMAGED": 3,
                  "PO_LINE_CANCELED": 4,
                  "PO_LINE_ARCHIVED": 5
                }
              },
              "VendorState": {
                "values": {
                  "VENDOR_DO_NOT_USE": 0,
                  "VENDOR_ACTIVE": 1,
                  "VENDOR_INACTIVE": 2
                }
              },
              "Attribute": {
                "fields": {
                  "definitionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "intValue": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "stringValue": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CatalogObject": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.items.merchant.CatalogObjectType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "attribute": {
                    "type": ".squareup.inventory.v3.Attribute",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "version": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "cogsId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "deleted": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "PurchaseOrder": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "displayToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "lineItem": {
                    "type": ".squareup.inventory.v3.PurchaseOrder.Line",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "charge": {
                    "type": ".squareup.inventory.v3.PurchaseOrder.Charge",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "totalTaxAmount": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "totalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.inventory.v3.PurchaseOrderState",
                    "id": 7,
                    "rule": "optional"
                  },
                  "stateChangedAt": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "stateChangedBy": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "vendor": {
                    "type": ".squareup.inventory.v3.Vendor",
                    "id": 10,
                    "rule": "optional"
                  },
                  "destination": {
                    "type": ".squareup.inventory.v3.PurchaseOrder.Destination",
                    "id": 11,
                    "rule": "optional"
                  },
                  "tax": {
                    "type": ".squareup.inventory.v3.CatalogObject",
                    "id": 12,
                    "rule": "optional"
                  },
                  "notes": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "expectedAt": {
                    "type": "int64",
                    "id": 16,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 14,
                    "rule": "optional"
                  },
                  "createdBy": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "int64",
                    "id": 15,
                    "rule": "optional"
                  },
                  "updatedBy": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "schemaVersion": {
                    "type": "int32",
                    "id": 19,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Line": {
                    "fields": {
                      "lineNumber": {
                        "type": "int32",
                        "id": 1,
                        "rule": "optional"
                      },
                      "parentLineNumber": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "product": {
                        "type": ".squareup.inventory.v3.PurchaseOrder.Line.Product",
                        "id": 3,
                        "rule": "optional"
                      },
                      "quantity": {
                        "type": ".squareup.inventory.v3.Quantity",
                        "id": 4,
                        "rule": "optional"
                      },
                      "unitCostAmount": {
                        "type": ".squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "totalCostAmount": {
                        "type": ".squareup.common.Money",
                        "id": 14,
                        "rule": "optional"
                      },
                      "feeAmount": {
                        "type": ".squareup.common.Money",
                        "id": 6,
                        "rule": "optional"
                      },
                      "state": {
                        "type": ".squareup.inventory.v3.PurchaseOrderLineState",
                        "id": 8,
                        "rule": "optional"
                      },
                      "stateChangedAt": {
                        "type": "int64",
                        "id": 9,
                        "rule": "optional"
                      },
                      "stateChangedBy": {
                        "type": "string",
                        "id": 10,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "int64",
                        "id": 12,
                        "rule": "optional"
                      },
                      "updatedAt": {
                        "type": "int64",
                        "id": 13,
                        "rule": "optional"
                      },
                      "notes": {
                        "type": "string",
                        "id": 15,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Product": {
                        "fields": {
                          "item": {
                            "type": ".squareup.inventory.v3.CatalogObject",
                            "id": 1,
                            "rule": "optional"
                          },
                          "itemVariation": {
                            "type": ".squareup.inventory.v3.CatalogObject",
                            "id": 2,
                            "rule": "optional"
                          },
                          "vendorSku": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "unitCost": {
                            "type": ".squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "catalogVersion": {
                            "type": "int64",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "Charge": {
                    "fields": {
                      "chargeNumber": {
                        "type": "int32",
                        "id": 1,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "amount": {
                        "type": ".squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "taxAmount": {
                        "type": ".squareup.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "tax": {
                        "type": ".squareup.inventory.v3.CatalogObject",
                        "id": 5,
                        "rule": "optional"
                      },
                      "associatedLines": {
                        "type": ".squareup.inventory.v3.PurchaseOrder.Charge.AssociatedLine",
                        "id": 6,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "AssociatedLine": {
                        "fields": {
                          "lineNumber": {
                            "type": "int32",
                            "id": 1,
                            "rule": "optional"
                          },
                          "proratedAmount": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "proratedTaxAmount": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "Destination": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "unitNickname": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "addressToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "address": {
                        "type": ".squareup.common.location.GlobalAddress",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "Vendor": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "addressToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 4,
                    "rule": "optional"
                  },
                  "contactName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "accountNumber": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "notes": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.inventory.v3.VendorState",
                    "id": 12,
                    "rule": "optional"
                  },
                  "contacts": {
                    "type": ".squareup.inventory.v3.VendorContact",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "version": {
                    "type": "uint64",
                    "id": 14,
                    "rule": "optional"
                  }
                }
              },
              "VendorContact": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "emailAddress": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "removed": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "ordinal": {
                    "type": "uint64",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "TotalCostOfGoods": {
                "fields": {
                  "totalCostMoney": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": ".squareup.inventory.v3.Quantity",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "InventoryEventType": {
                "values": {
                  "DO_NOT_USE": 0,
                  "SALE": 1,
                  "RESTOCK": 2,
                  "RECEIVED": 3,
                  "DAMAGED": 4,
                  "LOSS": 5,
                  "RECOUNT": 6,
                  "TRANSFER": 7,
                  "CANCELED_SALE": 8,
                  "AVAILABILITY_CHANGE": 9,
                  "COMMITMENT_LINE_CHANGE": 10,
                  "STOCK_TRACKING_CHANGE": 11,
                  "IN_TRANSIT": 12
                }
              },
              "InventoryEvent": {
                "fields": {
                  "eventType": {
                    "type": ".squareup.inventory.v3.InventoryEventType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "itemName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "variationName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "variationSku": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "costLots": {
                    "type": ".squareup.inventory.v3.TotalCostOfGoods",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "objectDeleted": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "connectOauthClientName": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "inferredAdjustment": {
                    "type": ".squareup.inventory.v3.Adjustment",
                    "id": 10,
                    "rule": "optional"
                  },
                  "defaultCost": {
                    "type": ".squareup.common.Money",
                    "id": 11,
                    "rule": "optional"
                  },
                  "maxEditableQuantity": {
                    "type": ".squareup.inventory.v3.Quantity",
                    "id": 12,
                    "rule": "optional"
                  },
                  "vendors": {
                    "type": ".squareup.inventory.v3.Vendor",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "defaultVendor": {
                    "type": ".squareup.inventory.v3.Vendor",
                    "id": 14,
                    "rule": "optional"
                  },
                  "linkedRestockOriginalSaleUnitToken": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "measurementUnit": {
                    "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogMeasurementUnit",
                    "id": 16,
                    "rule": "optional"
                  },
                  "variationUpc": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "componentInformation": {
                    "type": ".squareup.inventory.v3.InventoryEvent.ComponentInformation",
                    "id": 19,
                    "rule": "optional"
                  },
                  "measurementUnitToken": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "rootAdjustmentInformation": {
                    "type": ".squareup.inventory.v3.InventoryEvent.RootAdjustmentInformation",
                    "id": 22,
                    "rule": "optional"
                  },
                  "stockCount": {
                    "type": ".squareup.inventory.v3.Count",
                    "id": 1
                  },
                  "adjustment": {
                    "type": ".squareup.inventory.v3.Adjustment",
                    "id": 2
                  },
                  "productState": {
                    "type": ".squareup.inventory.v3.ProductState",
                    "id": 18
                  },
                  "commitmentLine": {
                    "type": ".squareup.inventory.v3.CommitmentRequestAuditLineItem",
                    "id": 21
                  },
                  "stockTrackingChange": {
                    "type": ".squareup.inventory.v3.StockTrackingChange",
                    "id": 23
                  }
                },
                "nested": {
                  "ComponentInformation": {
                    "fields": {
                      "productIdentifier": {
                        "type": ".squareup.inventory.v3.ProductIdentifier",
                        "id": 1,
                        "rule": "optional"
                      },
                      "measurementUnit": {
                        "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogMeasurementUnit",
                        "id": 2,
                        "rule": "optional"
                      },
                      "component": {
                        "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogComponent",
                        "id": 3,
                        "rule": "optional"
                      },
                      "compositionQuantity": {
                        "type": ".squareup.connect.v2.merchant_catalog.resources.QuantityRatio",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "RootAdjustmentInformation": {
                    "fields": {
                      "productIdentifier": {
                        "type": ".squareup.inventory.v3.ProductIdentifier",
                        "id": 1,
                        "rule": "optional"
                      },
                      "itemName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "variationName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "measurementUnit": {
                        "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogMeasurementUnit",
                        "id": 4,
                        "rule": "optional"
                      },
                      "measurementUnitToken": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "compositionType": {
                        "type": ".squareup.connect.v2.merchant_catalog.resources.CompositionType",
                        "id": 6,
                        "rule": "optional"
                      },
                      "quantityDecimal": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "isDeleted": {
                        "type": "bool",
                        "id": 8,
                        "rule": "optional"
                      },
                      "composedObjectType": {
                        "type": ".squareup.inventory.inventory_common.ComposedObjectType",
                        "id": 9,
                        "rule": "optional"
                      }
                    }
                  },
                  "event": {
                    "oneof": ["stockCount", "adjustment", "productState", "commitmentLine", "stockTrackingChange"]
                  }
                }
              },
              "AggregatedInventoryEvent": {
                "fields": {
                  "inventoryEvents": {
                    "type": ".squareup.inventory.v3.InventoryEvent",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "CommitmentRequestAuditLineItem": {
                "fields": {
                  "commitment": {
                    "type": ".squareup.inventory.v3.CommitmentRequestAudit",
                    "id": 1,
                    "rule": "optional"
                  },
                  "lineChange": {
                    "type": ".squareup.inventory.v3.CommitmentChange",
                    "id": 2,
                    "rule": "optional"
                  },
                  "adjustments": {
                    "type": ".squareup.inventory.v3.Adjustment",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "CommitmentRequestAudit": {
                "fields": {
                  "occurredAt": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "receivedAt": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "commitmentId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sequenceId": {
                    "type": "uint64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "anchorType": {
                    "type": ".squareup.inventory.v3.CommitmentAnchorType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "anchorId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "ProductLabelTemplate": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "provider": {
                    "type": ".squareup.inventory.v3.ProductLabelTemplate.Provider",
                    "id": 3,
                    "rule": "optional"
                  },
                  "restrictConfiguration": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "labelColumnCount": {
                    "type": "uint64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "labelRowCount": {
                    "type": "uint64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "isDeprecated": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Provider": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "AVERY": 1,
                      "ZEBRA": 2,
                      "DYMO": 3
                    }
                  }
                }
              },
              "ProductInfoForLabels": {
                "fields": {
                  "itemName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "itemVariationName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "itemVariationToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sku": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "price": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "count": {
                    "type": "uint64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "measurementUnitAbbr": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "gtin": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "ProductLabelConfiguration": {
                "fields": {
                  "includeBarcode": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includeItemName": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "includeItemVariationName": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "includeRetailPrice": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "includeSku": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "includeMeasurementUnitAbbr": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "includeGtin": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "barcodeIdentifier": {
                    "type": ".squareup.inventory.v3.ProductLabelConfiguration.BarcodeIdentifier",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": "BARCODE_IDENTIFIER_NONE"
                    }
                  }
                },
                "nested": {
                  "BarcodeIdentifier": {
                    "values": {
                      "BARCODE_IDENTIFIER_DO_NOT_USE": 0,
                      "BARCODE_IDENTIFIER_NONE": 1,
                      "BARCODE_IDENTIFIER_SKU": 2,
                      "BARCODE_IDENTIFIER_GTIN": 3
                    }
                  }
                }
              },
              "ProductLabelTemplateWithConfiguration": {
                "fields": {
                  "template": {
                    "type": ".squareup.inventory.v3.ProductLabelTemplate",
                    "id": 1,
                    "rule": "optional"
                  },
                  "configuration": {
                    "type": ".squareup.inventory.v3.ProductLabelConfiguration",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ProductLabelGenerationOptions": {
                "fields": {
                  "template": {
                    "type": ".squareup.inventory.v3.ProductLabelTemplate",
                    "id": 1,
                    "rule": "optional"
                  },
                  "configuration": {
                    "type": ".squareup.inventory.v3.ProductLabelConfiguration",
                    "id": 2,
                    "rule": "optional"
                  },
                  "products": {
                    "type": ".squareup.inventory.v3.ProductInfoForLabels",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "startRow": {
                    "type": "uint64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "startColumn": {
                    "type": "uint64",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ProductState": {
                "fields": {
                  "productIdentifier": {
                    "type": ".squareup.inventory.v3.ProductIdentifier",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "inventoryType": {
                    "type": ".squareup.inventory.inventory_common.InventoryType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "trackingState": {
                    "type": ".squareup.inventory.v3.TrackingState",
                    "id": 4,
                    "rule": "optional"
                  },
                  "validUntil": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "occurredAt": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "ReturnBinItem": {
                "fields": {
                  "itemName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemVariationName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "itemVariationSku": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "originalReturnAdjustment": {
                    "type": ".squareup.inventory.v3.Adjustment",
                    "id": 4,
                    "rule": "optional"
                  },
                  "restockableQuantity": {
                    "type": ".squareup.inventory.v3.Quantity",
                    "id": 5,
                    "rule": "optional"
                  },
                  "itemVariationGtin": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "CommitmentState": {
                "values": {
                  "DO_NOT_USE_COMMITMENT_STATE": 0,
                  "COMMITTED": 1,
                  "RESOLVED": 2,
                  "RELEASED": 3
                }
              },
              "Reservation": {
                "fields": {
                  "productToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "commitmentState": {
                    "type": ".squareup.inventory.v3.CommitmentState",
                    "id": 4,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": ".squareup.inventory.v3.Quantity",
                    "id": 5,
                    "rule": "optional"
                  },
                  "quantityDecimal": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "LocationAvailability": {
                "fields": {
                  "productToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isAvailable": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "availableQuantity": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "calculatedAt": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "inStockQuantity": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "committedQuantity": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "isTracked": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "isEstimated": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "availabilityRule": {
                    "type": ".squareup.inventory.v3.AvailabilityRuleType",
                    "id": 11,
                    "rule": "optional"
                  },
                  "availabilityRuleExpiresAt": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              },
              "CommitmentAnchorType": {
                "values": {
                  "DO_NOT_USE_COMMITMENT_ANCHOR_TYPE": 0,
                  "RST_CHECK": 1,
                  "INVOICE": 2,
                  "ORDER": 3,
                  "DEMO": 4
                }
              },
              "CommitmentChange": {
                "fields": {
                  "anchorLineItemId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "productVersion": {
                    "type": "uint64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "productType": {
                    "type": ".squareup.inventory.v3.ProductType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "committedStateDelta": {
                    "type": ".squareup.inventory.v3.CommitmentChange.CommitmentStateDelta",
                    "id": 6,
                    "rule": "optional"
                  },
                  "releasedStateDelta": {
                    "type": ".squareup.inventory.v3.CommitmentChange.CommitmentStateDelta",
                    "id": 7,
                    "rule": "optional"
                  },
                  "resolvedStateDelta": {
                    "type": ".squareup.inventory.v3.CommitmentChange.CommitmentStateDelta",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CommitmentStateDelta": {
                    "fields": {
                      "state": {
                        "type": ".squareup.inventory.v3.CommitmentState",
                        "id": 1,
                        "rule": "optional"
                      },
                      "beforeQuantity": {
                        "type": ".squareup.inventory.v3.Quantity",
                        "id": 2,
                        "rule": "optional"
                      },
                      "afterQuantity": {
                        "type": ".squareup.inventory.v3.Quantity",
                        "id": 3,
                        "rule": "optional"
                      },
                      "deltaQuantity": {
                        "type": ".squareup.inventory.v3.Quantity",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "StockAlertType": {
                "values": {
                  "DO_NOT_USE_ALERT_TYPE": 0,
                  "RESERVED": 1,
                  "LOW_QUANTITY": 2
                }
              },
              "StockAlertValue": {
                "values": {
                  "DO_NOT_USE_STOCK_ALERT_VALUE": 0,
                  "OUT": 1,
                  "LOW": 2
                }
              },
              "StockAlert": {
                "fields": {
                  "productToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.inventory.v3.StockAlertType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "value": {
                    "type": ".squareup.inventory.v3.StockAlertValue",
                    "id": 4,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "AvailabilityRuleType": {
                "values": {
                  "DO_NOT_USE_AVAILABILITY_RULE_TYPE": 0,
                  "STOCK": 1,
                  "COMPOSITION": 2,
                  "SALES_LIMIT_QUANTITY": 3,
                  "FORCE_UNAVAILABLE": 4,
                  "FORCE_AVAILABLE": 5,
                  "UNRECOGNIZED_AVAILABILITY_RULE_TYPE": 6,
                  "DEFAULT_AVAILABILITY": 7
                }
              },
              "ProductConfiguration": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "productType": {
                    "type": ".squareup.inventory.v3.ProductType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "catalogVersion": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "inventoryTracking": {
                    "type": ".squareup.inventory.v3.InventoryTracking",
                    "id": 8,
                    "rule": "optional"
                  },
                  "removeInventoryTracking": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "stockAlerts": {
                    "type": ".squareup.inventory.v3.StockAlertConfiguration",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "availabilityConfiguration": {
                    "type": ".squareup.inventory.v3.AvailabilityConfiguration",
                    "id": 11,
                    "rule": "optional"
                  },
                  "requestCatalogVersion": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "forceUpdate": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  }
                }
              },
              "StockAlertConfiguration": {
                "fields": {
                  "type": {
                    "type": ".squareup.inventory.v3.StockAlertType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "threshold": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isActive": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "locationToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "InventoryTracking": {
                "fields": {
                  "globalState": {
                    "type": ".squareup.inventory.v3.InventoryTracking.State",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationStates": {
                    "type": ".squareup.inventory.v3.InventoryTracking.LocationState",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "removeAllLocationStates": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "disableSoldOutOverrides": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "State": {
                    "values": {
                      "INVENTORY_TRACKING_STATE_DO_NOT_USE": 0,
                      "NOT_TRACKING": 1,
                      "TRACKING": 2,
                      "UNSET": 4
                    }
                  },
                  "LocationState": {
                    "fields": {
                      "locationToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "state": {
                        "type": ".squareup.inventory.v3.InventoryTracking.State",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "StockTrackingChange": {
                "fields": {
                  "productToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "productConfigurationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "productConfigurationVersion": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "catalogVersion": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "productType": {
                    "type": ".squareup.inventory.v3.ProductType",
                    "id": 6,
                    "rule": "optional"
                  },
                  "occurredAt": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "newTrackingState": {
                    "type": ".squareup.inventory.v3.InventoryTracking.State",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "AvailabilityConfiguration": {
                "fields": {
                  "globalDefault": {
                    "type": ".squareup.inventory.v3.AvailabilityStrategy",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationDefaults": {
                    "type": ".squareup.inventory.v3.AvailabilityStrategy",
                    "id": 2,
                    "keyType": "string"
                  },
                  "locationOverrides": {
                    "type": ".squareup.inventory.v3.AvailabilityStrategy",
                    "id": 3,
                    "keyType": "string"
                  },
                  "globalDefaultRule": {
                    "type": ".squareup.inventory.v3.AvailabilityRule",
                    "id": 4,
                    "rule": "optional"
                  },
                  "locationDefaultRule": {
                    "type": ".squareup.inventory.v3.AvailabilityRule",
                    "id": 5,
                    "keyType": "string"
                  },
                  "locationOverrideRule": {
                    "type": ".squareup.inventory.v3.AvailabilityRule",
                    "id": 6,
                    "keyType": "string"
                  }
                }
              },
              "AvailabilityStrategy": {
                "fields": {
                  "rules": {
                    "type": ".squareup.inventory.v3.AvailabilityRule",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "replace": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "AvailabilityRule": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "ruleType": {
                    "type": ".squareup.inventory.v3.AvailabilityRuleType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "expiresAt": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "deleted": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.ProductType && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.TrackingState && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.AccountingMethod && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.InventoryObjectType && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.State && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.State?.nested?.SqState && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.Quantity && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.ProductIdentifier && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.LegacyCogsIdentifier && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.Count && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.Adjustment && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.AdjustmentGroup && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.CostLot && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.PurchaseOrderState && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.PurchaseOrderLineState && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.VendorState && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.Attribute && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.CatalogObject && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.PurchaseOrder && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.PurchaseOrder?.nested?.Line && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.PurchaseOrder?.nested?.Line?.nested?.Product && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.PurchaseOrder?.nested?.Charge && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.PurchaseOrder?.nested?.Charge?.nested?.AssociatedLine && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.PurchaseOrder?.nested?.Destination && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.Vendor && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.VendorContact && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.TotalCostOfGoods && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.InventoryEventType && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.InventoryEvent && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.InventoryEvent?.nested?.ComponentInformation && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.InventoryEvent?.nested?.RootAdjustmentInformation && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.AggregatedInventoryEvent && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.CommitmentRequestAuditLineItem && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.CommitmentRequestAudit && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.ProductLabelTemplate && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.ProductLabelTemplate?.nested?.Provider && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.ProductInfoForLabels && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.ProductLabelConfiguration && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.ProductLabelConfiguration?.nested?.BarcodeIdentifier && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.ProductLabelTemplateWithConfiguration && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.ProductLabelGenerationOptions && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.ProductState && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.ReturnBinItem && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.CommitmentState && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.Reservation && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.LocationAvailability && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.CommitmentAnchorType && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.CommitmentChange && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.CommitmentChange?.nested?.CommitmentStateDelta && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.StockAlertType && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.StockAlertValue && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.StockAlert && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.AvailabilityRuleType && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.ProductConfiguration && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.StockAlertConfiguration && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.InventoryTracking && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.InventoryTracking?.nested?.State && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.InventoryTracking?.nested?.LocationState && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.StockTrackingChange && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.AvailabilityConfiguration && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.AvailabilityStrategy && !$root.nested?.squareup?.nested?.inventory?.nested?.v3?.nested?.AvailabilityRule) {
  $root.addJSON(jsonData);
}

/**
 * TODO(seiler): Notification endpoints.
 *
 * SOURCE ProductType @ squareup/inventory/api.proto at 24:1
 */
export const ProductType = $root.lookupEnum('squareup.inventory.v3.ProductType').values;
/**
 * SOURCE TrackingState @ squareup/inventory/api.proto at 31:1
 */
export const TrackingState = $root.lookupEnum('squareup.inventory.v3.TrackingState').values;
/**
 * Account Method enumeration for Cost Lot allocations.
 *
 * SOURCE AccountingMethod @ squareup/inventory/api.proto at 62:1
 */
export const AccountingMethod = $root.lookupEnum('squareup.inventory.v3.AccountingMethod').values;
/**
 * SOURCE InventoryObjectType @ squareup/inventory/api.proto at 92:1
 */
export const InventoryObjectType = $root.lookupEnum('squareup.inventory.v3.InventoryObjectType').values;
/**
 * Inventory state models each step in the lifecycle of goods.
 *
 * SOURCE State @ squareup/inventory/api.proto at 127:1
 */
export const State = $root.lookupType('squareup.inventory.v3.State');
fixType(State);
Builder.createAndAttachToType(State);
/**
 * SOURCE SqState @ squareup/inventory/api.proto at 128:3
 */
State.SqState = $root.lookupEnum('squareup.inventory.v3.State.SqState').values;
/**
 * An amount of inventory. Typically, this is just a count, but this abstraction is designed to
 * support fractional inventory. The fractional portion is always additive.
 *
 * Examples:
 *   For 100 units: { count: 100 }
 *   For 2.5: { count: 2, fractional_count: 50000 }
 *   For -0.5: {count -1, fractional_count: 50000 }
 *
 * SOURCE Quantity @ squareup/inventory/api.proto at 246:1
 */
export const Quantity = $root.lookupType('squareup.inventory.v3.Quantity');
fixType(Quantity);
Builder.createAndAttachToType(Quantity);
/**
 * Uniquely identifies a product. Either merchant_catalog_token or (legacy_cogs_id, unit_token) must be specified.
 *
 * SOURCE ProductIdentifier @ squareup/inventory/api.proto at 263:1
 */
export const ProductIdentifier = $root.lookupType('squareup.inventory.v3.ProductIdentifier');
fixType(ProductIdentifier);
Builder.createAndAttachToType(ProductIdentifier);
/**
 * Uniquely identifies a product by a cogs id and a unit token.
 *
 * SOURCE LegacyCogsIdentifier @ squareup/inventory/api.proto at 285:1
 */
export const LegacyCogsIdentifier = $root.lookupType('squareup.inventory.v3.LegacyCogsIdentifier');
fixType(LegacyCogsIdentifier);
Builder.createAndAttachToType(LegacyCogsIdentifier);
/**
 * An inventory count indicates that a certain quantity of a product is in a certain state.
 *
 * SOURCE Count @ squareup/inventory/api.proto at 297:1
 */
export const Count = $root.lookupType('squareup.inventory.v3.Count');
fixType(Count);
Builder.createAndAttachToType(Count);
/**
 * This represents a change in inventory, and is the core model of the inventory system.
 * Inventory always moves from one state to another, except for new inventory which may enter the
 * system without a previous state.
 *
 * SOURCE Adjustment @ squareup/inventory/api.proto at 451:1
 */
export const Adjustment = $root.lookupType('squareup.inventory.v3.Adjustment');
fixType(Adjustment);
Builder.createAndAttachToType(Adjustment);
/**
 * SOURCE AdjustmentGroup @ squareup/inventory/api.proto at 604:1
 */
export const AdjustmentGroup = $root.lookupType('squareup.inventory.v3.AdjustmentGroup');
fixType(AdjustmentGroup);
Builder.createAndAttachToType(AdjustmentGroup);
/**
 * Cost Lot represents a cost and quantity of a product moved to a particular state by an Adjustment.
 *
 * SOURCE CostLot @ squareup/inventory/api.proto at 630:1
 */
export const CostLot = $root.lookupType('squareup.inventory.v3.CostLot');
fixType(CostLot);
Builder.createAndAttachToType(CostLot);
/**
 * PurchaseOrderState models each step in the lifecycle of a purchase order.
 *
 * SOURCE PurchaseOrderState @ squareup/inventory/api.proto at 695:1
 */
export const PurchaseOrderState = $root.lookupEnum('squareup.inventory.v3.PurchaseOrderState').values;
/**
 * PurchaseOrderLineState models each step in the lifecycle of a purchase order line item.
 *
 * SOURCE PurchaseOrderLineState @ squareup/inventory/api.proto at 732:1
 */
export const PurchaseOrderLineState = $root.lookupEnum('squareup.inventory.v3.PurchaseOrderLineState').values;
/**
 * VendorState indicates whether or not a vendor is currently active
 *
 * SOURCE VendorState @ squareup/inventory/api.proto at 761:1
 */
export const VendorState = $root.lookupEnum('squareup.inventory.v3.VendorState').values;
/**
 * Same as items.merchant.Attribute, but can be marshalled to JSON.
 *
 * SOURCE Attribute @ squareup/inventory/api.proto at 871:1
 */
export const Attribute = $root.lookupType('squareup.inventory.v3.Attribute');
fixType(Attribute);
Builder.createAndAttachToType(Attribute);
/**
 * Same as items.merchant.CatalogObject, but can be marshalled to JSON.
 * DO NOT USE. Deprecated in favor of using items.merchant.CatalogObject.
 *
 * SOURCE CatalogObject @ squareup/inventory/api.proto at 881:1
 */
export const CatalogObject = $root.lookupType('squareup.inventory.v3.CatalogObject');
fixType(CatalogObject);
Builder.createAndAttachToType(CatalogObject);
/**
 * A purchase order represents a request sent to a particular supplier to purchase goods to be sold.
 *
 * SOURCE PurchaseOrder @ squareup/inventory/api.proto at 900:1
 */
export const PurchaseOrder = $root.lookupType('squareup.inventory.v3.PurchaseOrder');
fixType(PurchaseOrder);
Builder.createAndAttachToType(PurchaseOrder);
/**
 * A purchase order consists of one or more line items, indicating a quantity of products to be
 * purchased.
 *
 * SOURCE Line @ squareup/inventory/api.proto at 915:3
 */
PurchaseOrder.Line = $root.lookupType('squareup.inventory.v3.PurchaseOrder.Line');
fixType(PurchaseOrder.Line);
Builder.createAndAttachToType(PurchaseOrder.Line);
/**
 * Product to be purchased.
 *
 * SOURCE Product @ squareup/inventory/api.proto at 926:5
 */
PurchaseOrder.Line.Product = $root.lookupType('squareup.inventory.v3.PurchaseOrder.Line.Product');
fixType(PurchaseOrder.Line.Product);
Builder.createAndAttachToType(PurchaseOrder.Line.Product);
/**
 * A purchase order may include one or more charges, such as shipping or handling.
 *
 * SOURCE Charge @ squareup/inventory/api.proto at 1003:3
 */
PurchaseOrder.Charge = $root.lookupType('squareup.inventory.v3.PurchaseOrder.Charge');
fixType(PurchaseOrder.Charge);
Builder.createAndAttachToType(PurchaseOrder.Charge);
/**
 * A charge is associated with one or more lines.
 * Required for schema_version >= 1.
 *
 * SOURCE AssociatedLine @ squareup/inventory/api.proto at 1027:5
 */
PurchaseOrder.Charge.AssociatedLine = $root.lookupType('squareup.inventory.v3.PurchaseOrder.Charge.AssociatedLine');
fixType(PurchaseOrder.Charge.AssociatedLine);
Builder.createAndAttachToType(PurchaseOrder.Charge.AssociatedLine);
/**
 * Location where to ship the products.
 *
 * SOURCE Destination @ squareup/inventory/api.proto at 1074:3
 */
PurchaseOrder.Destination = $root.lookupType('squareup.inventory.v3.PurchaseOrder.Destination');
fixType(PurchaseOrder.Destination);
Builder.createAndAttachToType(PurchaseOrder.Destination);
/**
 * A vendor is a supplier of goods for the merchants.
 *
 * SOURCE Vendor @ squareup/inventory/api.proto at 1137:1
 */
export const Vendor = $root.lookupType('squareup.inventory.v3.Vendor');
fixType(Vendor);
Builder.createAndAttachToType(Vendor);
/**
 * A VendorContact is a contact for a vendor.
 *
 * SOURCE VendorContact @ squareup/inventory/api.proto at 1204:1
 */
export const VendorContact = $root.lookupType('squareup.inventory.v3.VendorContact');
fixType(VendorContact, {
  name: {
    required: true
  }
});
Builder.createAndAttachToType(VendorContact);
/**
 * SOURCE TotalCostOfGoods @ squareup/inventory/api.proto at 1428:1
 */
export const TotalCostOfGoods = $root.lookupType('squareup.inventory.v3.TotalCostOfGoods');
fixType(TotalCostOfGoods);
Builder.createAndAttachToType(TotalCostOfGoods);
/**
 * Type of inventory event.
 *
 * SOURCE InventoryEventType @ squareup/inventory/api.proto at 1479:1
 */
export const InventoryEventType = $root.lookupEnum('squareup.inventory.v3.InventoryEventType').values;
/**
 * InventoryEvent stores information about a change in inventory.
 *
 * SOURCE InventoryEvent @ squareup/inventory/api.proto at 1533:1
 */
export const InventoryEvent = $root.lookupType('squareup.inventory.v3.InventoryEvent');
fixType(InventoryEvent);
Builder.createAndAttachToType(InventoryEvent);
/**
 * SOURCE ComponentInformation @ squareup/inventory/api.proto at 1610:3
 */
InventoryEvent.ComponentInformation = $root.lookupType('squareup.inventory.v3.InventoryEvent.ComponentInformation');
fixType(InventoryEvent.ComponentInformation);
Builder.createAndAttachToType(InventoryEvent.ComponentInformation);
/**
 * SOURCE RootAdjustmentInformation @ squareup/inventory/api.proto at 1634:3
 */
InventoryEvent.RootAdjustmentInformation = $root.lookupType('squareup.inventory.v3.InventoryEvent.RootAdjustmentInformation');
fixType(InventoryEvent.RootAdjustmentInformation);
Builder.createAndAttachToType(InventoryEvent.RootAdjustmentInformation);
/**
 * An AggregatedInventoryEvent stores a list of InventoryEvents which can be aggregated.
 * InventoryEvents can be aggregated if they have the same variation, location, and state transition.
 * Only InventoryEvents of type SALE and RETURN can be aggregated.
 *
 * SOURCE AggregatedInventoryEvent @ squareup/inventory/api.proto at 1680:1
 */
export const AggregatedInventoryEvent = $root.lookupType('squareup.inventory.v3.AggregatedInventoryEvent');
fixType(AggregatedInventoryEvent);
Builder.createAndAttachToType(AggregatedInventoryEvent);
/**
 * SOURCE CommitmentRequestAuditLineItem @ squareup/inventory/api.proto at 1686:1
 */
export const CommitmentRequestAuditLineItem = $root.lookupType('squareup.inventory.v3.CommitmentRequestAuditLineItem');
fixType(CommitmentRequestAuditLineItem);
Builder.createAndAttachToType(CommitmentRequestAuditLineItem);
/**
 * SOURCE CommitmentRequestAudit @ squareup/inventory/api.proto at 1692:1
 */
export const CommitmentRequestAudit = $root.lookupType('squareup.inventory.v3.CommitmentRequestAudit');
fixType(CommitmentRequestAudit);
Builder.createAndAttachToType(CommitmentRequestAudit);
/**
 * ProductLabelTemplate stores client-relevant data about a product label template.
 * It does not contain the full specifications of a given template.
 *
 * SOURCE ProductLabelTemplate @ squareup/inventory/api.proto at 1704:1
 */
export const ProductLabelTemplate = $root.lookupType('squareup.inventory.v3.ProductLabelTemplate');
fixType(ProductLabelTemplate);
Builder.createAndAttachToType(ProductLabelTemplate);
/**
 * The Provider specifies the source of a product label template.
 *
 * SOURCE Provider @ squareup/inventory/api.proto at 1707:3
 */
ProductLabelTemplate.Provider = $root.lookupEnum('squareup.inventory.v3.ProductLabelTemplate.Provider').values;
/**
 * ProductInfoForLabels specifies all relevant information about a product such that labels may be generated for it.
 *
 * SOURCE ProductInfoForLabels @ squareup/inventory/api.proto at 1759:1
 */
export const ProductInfoForLabels = $root.lookupType('squareup.inventory.v3.ProductInfoForLabels');
fixType(ProductInfoForLabels);
Builder.createAndAttachToType(ProductInfoForLabels);
/**
 * ProductLabelConfiguration specifies which label details to include on printed labels.
 *
 * SOURCE ProductLabelConfiguration @ squareup/inventory/api.proto at 1799:1
 */
export const ProductLabelConfiguration = $root.lookupType('squareup.inventory.v3.ProductLabelConfiguration');
fixType(ProductLabelConfiguration);
Builder.createAndAttachToType(ProductLabelConfiguration);
/**
 * The type of barcode that should be printed (sku or gtin), or none.
 *
 * SOURCE BarcodeIdentifier @ squareup/inventory/api.proto at 1802:3
 */
ProductLabelConfiguration.BarcodeIdentifier = $root.lookupEnum('squareup.inventory.v3.ProductLabelConfiguration.BarcodeIdentifier').values;
/**
 * ProductLabelTemplateWithConfiguration pairs a label template with a configuration.
 *
 * SOURCE ProductLabelTemplateWithConfiguration @ squareup/inventory/api.proto at 1855:1
 */
export const ProductLabelTemplateWithConfiguration = $root.lookupType('squareup.inventory.v3.ProductLabelTemplateWithConfiguration');
fixType(ProductLabelTemplateWithConfiguration);
Builder.createAndAttachToType(ProductLabelTemplateWithConfiguration);
/**
 * ProductLabelGenerationOptions specifies what labels should be generated and how they should be generated.
 *
 * SOURCE ProductLabelGenerationOptions @ squareup/inventory/api.proto at 1867:1
 */
export const ProductLabelGenerationOptions = $root.lookupType('squareup.inventory.v3.ProductLabelGenerationOptions');
fixType(ProductLabelGenerationOptions);
Builder.createAndAttachToType(ProductLabelGenerationOptions);
/**
 * ProductState can be used in a put request to modify the tracking state of a product.
 * Currently offline mode is not supported when product states are involved.
 *
 * SOURCE ProductState @ squareup/inventory/api.proto at 1907:1
 */
export const ProductState = $root.lookupType('squareup.inventory.v3.ProductState');
fixType(ProductState);
Builder.createAndAttachToType(ProductState);
/**
 * A ReturnBinItem is a restockable returned product linked to a return that has not been damaged or restocked yet.
 *
 * SOURCE ReturnBinItem @ squareup/inventory/api.proto at 2014:1
 */
export const ReturnBinItem = $root.lookupType('squareup.inventory.v3.ReturnBinItem');
fixType(ReturnBinItem);
Builder.createAndAttachToType(ReturnBinItem);
/**
 * SOURCE CommitmentState @ squareup/inventory/api.proto at 2040:1
 */
export const CommitmentState = $root.lookupEnum('squareup.inventory.v3.CommitmentState').values;
/**
 * Reservation is the particular stockable product quantities that are held for a given Commitment.
 *
 * SOURCE Reservation @ squareup/inventory/api.proto at 2075:1
 */
export const Reservation = $root.lookupType('squareup.inventory.v3.Reservation');
fixType(Reservation);
Builder.createAndAttachToType(Reservation);
/**
 * Location Availability represents the ability to sell a catalog object at a given location. The absence of this object
 * indicates that the catalog object hasn't interacted with the inventory features at the given location.
 *
 * SOURCE LocationAvailability @ squareup/inventory/api.proto at 2126:1
 */
export const LocationAvailability = $root.lookupType('squareup.inventory.v3.LocationAvailability');
fixType(LocationAvailability);
Builder.createAndAttachToType(LocationAvailability);
/**
 * SOURCE CommitmentAnchorType @ squareup/inventory/api.proto at 2174:1
 */
export const CommitmentAnchorType = $root.lookupEnum('squareup.inventory.v3.CommitmentAnchorType').values;
/**
 * SOURCE CommitmentChange @ squareup/inventory/api.proto at 2278:1
 */
export const CommitmentChange = $root.lookupType('squareup.inventory.v3.CommitmentChange');
fixType(CommitmentChange);
Builder.createAndAttachToType(CommitmentChange);
/**
 * SOURCE CommitmentStateDelta @ squareup/inventory/api.proto at 2299:3
 */
CommitmentChange.CommitmentStateDelta = $root.lookupType('squareup.inventory.v3.CommitmentChange.CommitmentStateDelta');
fixType(CommitmentChange.CommitmentStateDelta);
Builder.createAndAttachToType(CommitmentChange.CommitmentStateDelta);
/**
 * SOURCE StockAlertType @ squareup/inventory/api.proto at 2408:1
 */
export const StockAlertType = $root.lookupEnum('squareup.inventory.v3.StockAlertType').values;
/**
 * SOURCE StockAlertValue @ squareup/inventory/api.proto at 2417:1
 */
export const StockAlertValue = $root.lookupEnum('squareup.inventory.v3.StockAlertValue').values;
/**
 * SOURCE StockAlert @ squareup/inventory/api.proto at 2425:1
 */
export const StockAlert = $root.lookupType('squareup.inventory.v3.StockAlert');
fixType(StockAlert);
Builder.createAndAttachToType(StockAlert);
/**
 * SOURCE AvailabilityRuleType @ squareup/inventory/api.proto at 2445:1
 */
export const AvailabilityRuleType = $root.lookupEnum('squareup.inventory.v3.AvailabilityRuleType').values;
/**
 * SOURCE ProductConfiguration @ squareup/inventory/api.proto at 2470:1
 */
export const ProductConfiguration = $root.lookupType('squareup.inventory.v3.ProductConfiguration');
fixType(ProductConfiguration);
Builder.createAndAttachToType(ProductConfiguration);
/**
 * SOURCE StockAlertConfiguration @ squareup/inventory/api.proto at 2510:1
 */
export const StockAlertConfiguration = $root.lookupType('squareup.inventory.v3.StockAlertConfiguration');
fixType(StockAlertConfiguration);
Builder.createAndAttachToType(StockAlertConfiguration);
/**
 * SOURCE InventoryTracking @ squareup/inventory/api.proto at 2520:1
 */
export const InventoryTracking = $root.lookupType('squareup.inventory.v3.InventoryTracking');
fixType(InventoryTracking);
Builder.createAndAttachToType(InventoryTracking);
/**
 * SOURCE State @ squareup/inventory/api.proto at 2521:3
 */
InventoryTracking.State = $root.lookupEnum('squareup.inventory.v3.InventoryTracking.State').values;
/**
 * SOURCE LocationState @ squareup/inventory/api.proto at 2541:3
 */
InventoryTracking.LocationState = $root.lookupType('squareup.inventory.v3.InventoryTracking.LocationState');
fixType(InventoryTracking.LocationState);
Builder.createAndAttachToType(InventoryTracking.LocationState);
/**
 * SOURCE StockTrackingChange @ squareup/inventory/api.proto at 2552:1
 */
export const StockTrackingChange = $root.lookupType('squareup.inventory.v3.StockTrackingChange');
fixType(StockTrackingChange);
Builder.createAndAttachToType(StockTrackingChange);
/**
 * AvailabilityConfiguration is a message that describes how availability is determined for a product.
 * It is structured as a set of default strategies, determined generally by properties of the product (e.g does it
 * track stock?, is it a composition?) and a set of location-specific overrides. Overrides should in general be more
 * direct indications of availability that are issued temporarily.
 * The order of precedence when determining availability should be:
 * 1. Location-specific overrides
 * 2. Location-specific defaults
 * 3. Global defaults
 *
 * SOURCE AvailabilityConfiguration @ squareup/inventory/api.proto at 2572:1
 */
export const AvailabilityConfiguration = $root.lookupType('squareup.inventory.v3.AvailabilityConfiguration');
fixType(AvailabilityConfiguration);
Builder.createAndAttachToType(AvailabilityConfiguration);
/**
 * SOURCE AvailabilityStrategy @ squareup/inventory/api.proto at 2604:1
 */
export const AvailabilityStrategy = $root.lookupType('squareup.inventory.v3.AvailabilityStrategy');
fixType(AvailabilityStrategy);
Builder.createAndAttachToType(AvailabilityStrategy);
/**
 * SOURCE AvailabilityRule @ squareup/inventory/api.proto at 2612:1
 */
export const AvailabilityRule = $root.lookupType('squareup.inventory.v3.AvailabilityRule');
fixType(AvailabilityRule);
Builder.createAndAttachToType(AvailabilityRule);